import AppRoutes from "./routes/AppRoute";
import Auth0ProviderWithNavigate from "./auth0/Auth0ProviderWithNavigate";
import Alert from "./components/Alert/Alert";
import { globalAlertManager } from "./components/Alert/alertManager";

export default function App() {
  return (
    <main id="main-content">
      <Auth0ProviderWithNavigate>
        <AppRoutes />
      </Auth0ProviderWithNavigate>
      <Alert
        alertManager={globalAlertManager}
        theme="light"
        variant="solid"
        position="bottom-right"
      />
    </main>
  );
}
